import type { Resource } from '../../';
export const product_details_preorder: Resource = {"default":"Preorder"};
